import React from "react";
import { ReactNode } from "react";

import {
  ADIcon,
  AEIcon,
  AFIcon,
  AGIcon,
  AIIcon,
  ALIcon,
  AMIcon,
  AOIcon,
  ARIcon,
  ASIcon,
  ATIcon,
  AUIcon,
  AWIcon,
  AXIcon,
  AZIcon,
  BAIcon,
  BBIcon,
  BDIcon,
  BEIcon,
  BFIcon,
  BGIcon,
  BHIcon,
  BIIcon,
  BJIcon,
  BLIcon,
  BMIcon,
  BNIcon,
  BOIcon,
  BRIcon,
  BSIcon,
  BTIcon,
  BWIcon,
  BYIcon,
  BZIcon,
  CAIcon,
  CCIcon,
  CDIcon,
  CFIcon,
  CGIcon,
  CHIcon,
  CIIcon,
  CKIcon,
  CLIcon,
  CMIcon,
  CNIcon,
  COIcon,
  CRIcon,
  CUIcon,
  CVIcon,
  CWIcon,
  CXIcon,
  CYIcon,
  CZIcon,
  DEIcon,
  DJIcon,
  DKIcon,
  DMIcon,
  DOIcon,
  DZIcon,
  ECIcon,
  EEIcon,
  EGIcon,
  EHIcon,
  ERIcon,
  ESIcon,
  ETIcon,
  FIIcon,
  FJIcon,
  FKIcon,
  FMIcon,
  FOIcon,
  FRIcon,
  GAIcon,
  GDIcon,
  GEIcon,
  GFIcon,
  GGIcon,
  GHIcon,
  GIIcon,
  GLIcon,
  GMIcon,
  GNIcon,
  GPIcon,
  GQIcon,
  GRIcon,
  GTIcon,
  GUIcon,
  GWIcon,
  GYIcon,
  HKIcon,
  HNIcon,
  HRIcon,
  HTIcon,
  HUIcon,
  IDIcon,
  IEIcon,
  ILIcon,
  IMIcon,
  INIcon,
  IOIcon,
  IQIcon,
  IRIcon,
  ISIcon,
  ITIcon,
  JEIcon,
  JMIcon,
  JOIcon,
  JPIcon,
  KEIcon,
  KGIcon,
  KHIcon,
  KIIcon,
  KMIcon,
  KNIcon,
  KPIcon,
  KRIcon,
  KWIcon,
  KYIcon,
  KZIcon,
  LAIcon,
  LBIcon,
  LCIcon,
  LIIcon,
  LKIcon,
  LRIcon,
  LSIcon,
  LTIcon,
  LUIcon,
  LVIcon,
  LYIcon,
  MAIcon,
  MCIcon,
  MDIcon,
  MEIcon,
  MFIcon,
  MGIcon,
  MHIcon,
  MKIcon,
  MLIcon,
  MMIcon,
  MNIcon,
  MOIcon,
  MPIcon,
  MQIcon,
  MRIcon,
  MSIcon,
  MTIcon,
  MUIcon,
  MVIcon,
  MWIcon,
  MXIcon,
  MYIcon,
  MZIcon,
  NAIcon,
  NCIcon,
  NEIcon,
  NFIcon,
  NGIcon,
  NIIcon,
  NLIcon,
  NOIcon,
  NPIcon,
  NRIcon,
  NUIcon,
  NZIcon,
  OMIcon,
  PAIcon,
  PEIcon,
  PFIcon,
  PGIcon,
  PHIcon,
  PKIcon,
  PLIcon,
  PMIcon,
  PRIcon,
  PSIcon,
  PTIcon,
  PWIcon,
  PYIcon,
  QAIcon,
  REIcon,
  ROIcon,
  RSIcon,
  RUIcon,
  RWIcon,
  SAIcon,
  SBIcon,
  SCIcon,
  SDIcon,
  SEIcon,
  SGIcon,
  SHIcon,
  SIIcon,
  SJIcon,
  SKIcon,
  SLIcon,
  SMIcon,
  SNIcon,
  SOIcon,
  SRIcon,
  SSIcon,
  STIcon,
  SVIcon,
  SXIcon,
  SYIcon,
  SZIcon,
  TCIcon,
  TDIcon,
  TGIcon,
  THIcon,
  TJIcon,
  TKIcon,
  TLIcon,
  TMIcon,
  TNIcon,
  TOIcon,
  TRIcon,
  TTIcon,
  TVIcon,
  TWIcon,
  TZIcon,
  UAIcon,
  UGIcon,
  UKIcon,
  USIcon,
  UYIcon,
  UZIcon,
  VAIcon,
  VCIcon,
  VEIcon,
  VGIcon,
  VIIcon,
  VNIcon,
  VUIcon,
  WAIcon,
  WFIcon,
  YEIcon,
  YTUNFIcon,
  ZAIcon,
  ZMIcon,
  ZWIcon,
} from "../../../icons_v2/flags";

export type CountryCode = {
  id: string;
  name: string;
  code: number;
  regionCode: string;
  icon: ReactNode;
};

export const CountryCodes: CountryCode[] = [
  {
    id: "US",
    name: "United States",
    code: 1,
    regionCode: "us",
    icon: <USIcon testID="USFlagIcon" />,
  },
  {
    id: "AC",
    name: "Ascension Island",
    code: 247,
    regionCode: "ac",
    icon: null,
  },
  {
    id: "AD",
    name: "Andorra",
    code: 376,
    regionCode: "ad",
    icon: <ADIcon testID="ADFlagIcon" />,
  },
  {
    id: "AE",
    name: "United Arab Emirates",
    code: 971,
    regionCode: "ae",
    icon: <AEIcon testID="AEFlagIcon" />,
  },
  {
    id: "AF",
    name: "Afghanistan",
    code: 93,
    regionCode: "af",
    icon: <AFIcon testID="AFFlagIcon" />,
  },
  {
    id: "AG",
    name: "Antigua and Barbuda",
    code: 1,
    regionCode: "ag",
    icon: <AGIcon testID="AGFlagIcon" />,
  },
  {
    id: "AI",
    name: "Anguilla",
    code: 1,
    regionCode: "ai",
    icon: <AIIcon testID="AIFlagIcon" />,
  },
  {
    id: "AL",
    name: "Albania",
    code: 355,
    regionCode: "al",
    icon: <ALIcon testID="ALFlagIcon" />,
  },
  {
    id: "AM",
    name: "Armenia",
    code: 374,
    regionCode: "am",
    icon: <AMIcon testID="AMFlagIcon" />,
  },
  {
    id: "AO",
    name: "Angola",
    code: 244,
    regionCode: "ao",
    icon: <AOIcon testID="AOFlagIcon" />,
  },
  {
    id: "AR",
    name: "Argentina",
    code: 54,
    regionCode: "ar",
    icon: <ARIcon testID="ARFlagIcon" />,
  },
  {
    id: "AS",
    name: "American Samoa",
    code: 1,
    regionCode: "as",
    icon: <ASIcon testID="ASFlagIcon" />,
  },
  {
    id: "AT",
    name: "Austria",
    code: 43,
    regionCode: "at",
    icon: <ATIcon testID="ATFlagIcon" />,
  },
  {
    id: "AU",
    name: "Australia",
    code: 61,
    regionCode: "au",
    icon: <AUIcon testID="AUFlagIcon" />,
  },
  {
    id: "AW",
    name: "Aruba",
    code: 297,
    regionCode: "aw",
    icon: <AWIcon testID="AWFlagIcon" />,
  },
  {
    id: "AX",
    name: "Åland Islands",
    code: 358,
    regionCode: "ax",
    icon: <AXIcon testID="AXFlagIcon" />,
  },
  {
    id: "AZ",
    name: "Azerbaijan",
    code: 994,
    regionCode: "az",
    icon: <AZIcon testID="AZFlagIcon" />,
  },
  {
    id: "BA",
    name: "Bosnia and Herzegovina",
    code: 387,
    regionCode: "ba",
    icon: <BAIcon testID="BAFlagIcon" />,
  },
  {
    id: "BB",
    name: "Barbados",
    code: 1,
    regionCode: "bb",
    icon: <BBIcon testID="BBFlagIcon" />,
  },
  {
    id: "BD",
    name: "Bangladesh",
    code: 880,
    regionCode: "bd",
    icon: <BDIcon testID="BDFlagIcon" />,
  },
  {
    id: "BE",
    name: "Belgium",
    code: 32,
    regionCode: "be",
    icon: <BEIcon testID="BEFlagIcon" />,
  },
  {
    id: "BF",
    name: "Burkina Faso",
    code: 226,
    regionCode: "bf",
    icon: <BFIcon testID="BFFlagIcon" />,
  },
  {
    id: "BG",
    name: "Bulgaria",
    code: 359,
    regionCode: "bg",
    icon: <BGIcon testID="BGFlagIcon" />,
  },
  {
    id: "BH",
    name: "Bahrain",
    code: 973,
    regionCode: "bh",
    icon: <BHIcon testID="BHFlagIcon" />,
  },
  {
    id: "BI",
    name: "Burundi",
    code: 257,
    regionCode: "bi",
    icon: <BIIcon testID="BIFlagIcon" />,
  },
  {
    id: "BJ",
    name: "Benin",
    code: 229,
    regionCode: "bj",
    icon: <BJIcon testID="BJFlagIcon" />,
  },
  {
    id: "BL",
    name: "Saint Barthélemy",
    code: 590,
    regionCode: "bl",
    icon: <BLIcon testID="BLFlagIcon" />,
  },
  {
    id: "BM",
    name: "Bermuda",
    code: 1,
    regionCode: "bm",
    icon: <BMIcon testID="BMFlagIcon" />,
  },
  {
    id: "BN",
    name: "Brunei",
    code: 673,
    regionCode: "bn",
    icon: <BNIcon testID="BNFlagIcon" />,
  },
  {
    id: "BO",
    name: "Bolivia",
    code: 591,
    regionCode: "bo",
    icon: <BOIcon testID="BOFlagIcon" />,
  },
  {
    id: "BQ",
    name: "Caribbean Netherlands",
    code: 599,
    regionCode: "bq",
    icon: null,
  },
  {
    id: "BR",
    name: "Brazil",
    code: 55,
    regionCode: "br",
    icon: <BRIcon testID="BRFlagIcon" />,
  },
  {
    id: "BS",
    name: "Bahamas",
    code: 1,
    regionCode: "bs",
    icon: <BSIcon testID="BSFlagIcon" />,
  },
  {
    id: "BT",
    name: "Bhutan",
    code: 975,
    regionCode: "bt",
    icon: <BTIcon testID="BTFlagIcon" />,
  },
  {
    id: "BW",
    name: "Botswana",
    code: 267,
    regionCode: "bw",
    icon: <BWIcon testID="BWFlagIcon" />,
  },
  {
    id: "BY",
    name: "Belarus",
    code: 375,
    regionCode: "by",
    icon: <BYIcon testID="BYFlagIcon" />,
  },
  {
    id: "BZ",
    name: "Belize",
    code: 501,
    regionCode: "bz",
    icon: <BZIcon testID="BZFlagIcon" />,
  },
  {
    id: "CA",
    name: "Canada",
    code: 1,
    regionCode: "ca",
    icon: <CAIcon testID="CAFlagIcon" />,
  },
  {
    id: "CC",
    name: "Cocos (Keeling) Islands",
    code: 61,
    regionCode: "cc",
    icon: <CCIcon testID="CCFlagIcon" />,
  },
  {
    id: "CD",
    name: "DR Congo",
    code: 243,
    regionCode: "cd",
    icon: <CDIcon testID="CDFlagIcon" />,
  },
  {
    id: "CF",
    name: "Central African Republic",
    code: 236,
    regionCode: "cf",
    icon: <CFIcon testID="CFFlagIcon" />,
  },
  {
    id: "CG",
    name: "Republic of the Congo",
    code: 242,
    regionCode: "cg",
    icon: <CGIcon testID="CGFlagIcon" />,
  },
  {
    id: "CH",
    name: "Switzerland",
    code: 41,
    regionCode: "ch",
    icon: <CHIcon testID="CHFlagIcon" />,
  },
  {
    id: "CI",
    name: "Côte d'Ivoire",
    code: 225,
    regionCode: "ci",
    icon: <CIIcon testID="CIFlagIcon" />,
  },
  {
    id: "CK",
    name: "Cook Islands",
    code: 682,
    regionCode: "ck",
    icon: <CKIcon testID="CKFlagIcon" />,
  },
  {
    id: "CL",
    name: "Chile",
    code: 56,
    regionCode: "cl",
    icon: <CLIcon testID="CLFlagIcon" />,
  },
  {
    id: "CM",
    name: "Cameroon",
    code: 237,
    regionCode: "cm",
    icon: <CMIcon testID="CMFlagIcon" />,
  },
  {
    id: "CN",
    name: "China",
    code: 86,
    regionCode: "cn",
    icon: <CNIcon testID="CNFlagIcon" />,
  },
  {
    id: "CO",
    name: "Colombia",
    code: 57,
    regionCode: "co",
    icon: <COIcon testID="COFlagIcon" />,
  },
  {
    id: "CR",
    name: "Costa Rica",
    code: 506,
    regionCode: "cr",
    icon: <CRIcon testID="CRFlagIcon" />,
  },
  {
    id: "CU",
    name: "Cuba",
    code: 53,
    regionCode: "cu",
    icon: <CUIcon testID="CUFlagIcon" />,
  },
  {
    id: "CV",
    name: "Cape Verde",
    code: 238,
    regionCode: "cv",
    icon: <CVIcon testID="CVFlagIcon" />,
  },
  {
    id: "CW",
    name: "Curaçao",
    code: 599,
    regionCode: "cw",
    icon: <CWIcon testID="CWFlagIcon" />,
  },
  {
    id: "CX",
    name: "Christmas Island",
    code: 61,
    regionCode: "cx",
    icon: <CXIcon testID="CXFlagIcon" />,
  },
  {
    id: "CY",
    name: "Cyprus",
    code: 357,
    regionCode: "cy",
    icon: <CYIcon testID="CYFlagIcon" />,
  },
  {
    id: "CZ",
    name: "Czech Republic",
    code: 420,
    regionCode: "cz",
    icon: <CZIcon testID="CZFlagIcon" />,
  },
  {
    id: "DE",
    name: "Germany",
    code: 49,
    regionCode: "de",
    icon: <DEIcon testID="DEFlagIcon" />,
  },
  {
    id: "DJ",
    name: "Djibouti",
    code: 253,
    regionCode: "dj",
    icon: <DJIcon testID="DJFlagIcon" />,
  },
  {
    id: "DK",
    name: "Denmark",
    code: 45,
    regionCode: "dk",
    icon: <DKIcon testID="DKFlagIcon" />,
  },
  {
    id: "DM",
    name: "Dominica",
    code: 1,
    regionCode: "dm",
    icon: <DMIcon testID="DMFlagIcon" />,
  },
  {
    id: "DO",
    name: "Dominican Republic",
    code: 1,
    regionCode: "do",
    icon: <DOIcon testID="DOFlagIcon" />,
  },
  {
    id: "DZ",
    name: "Algeria",
    code: 213,
    regionCode: "dz",
    icon: <DZIcon testID="DZFlagIcon" />,
  },
  {
    id: "EC",
    name: "Ecuador",
    code: 593,
    regionCode: "ec",
    icon: <ECIcon testID="ECFlagIcon" />,
  },
  {
    id: "EE",
    name: "Estonia",
    code: 372,
    regionCode: "ee",
    icon: <EEIcon testID="EEFlagIcon" />,
  },
  {
    id: "EG",
    name: "Egypt",
    code: 20,
    regionCode: "eg",
    icon: <EGIcon testID="EGFlagIcon" />,
  },
  {
    id: "EH",
    name: "Western Sahara",
    code: 212,
    regionCode: "eh",
    icon: <EHIcon testID="EHFlagIcon" />,
  },
  {
    id: "ER",
    name: "Eritrea",
    code: 291,
    regionCode: "er",
    icon: <ERIcon testID="ERFlagIcon" />,
  },
  {
    id: "ES",
    name: "Spain",
    code: 34,
    regionCode: "es",
    icon: <ESIcon testID="ESFlagIcon" />,
  },
  {
    id: "ET",
    name: "Ethiopia",
    code: 251,
    regionCode: "et",
    icon: <ETIcon testID="ETFlagIcon" />,
  },
  {
    id: "FI",
    name: "Finland",
    code: 358,
    regionCode: "fi",
    icon: <FIIcon testID="FIFlagIcon" />,
  },
  {
    id: "FJ",
    name: "Fiji",
    code: 679,
    regionCode: "fj",
    icon: <FJIcon testID="FJFlagIcon" />,
  },
  {
    id: "FK",
    name: "Falkland Islands",
    code: 500,
    regionCode: "fk",
    icon: <FKIcon testID="FKFlagIcon" />,
  },
  {
    id: "FM",
    name: "Micronesia",
    code: 691,
    regionCode: "fm",
    icon: <FMIcon testID="FMFlagIcon" />,
  },
  {
    id: "FO",
    name: "Faroe Islands",
    code: 298,
    regionCode: "fo",
    icon: <FOIcon testID="FOFlagIcon" />,
  },
  {
    id: "FR",
    name: "France",
    code: 33,
    regionCode: "fr",
    icon: <FRIcon testID="FRFlagIcon" />,
  },
  {
    id: "GA",
    name: "Gabon",
    code: 241,
    regionCode: "ga",
    icon: <GAIcon testID="GAFlagIcon" />,
  },
  {
    id: "GB",
    name: "United Kingdom",
    code: 44,
    regionCode: "gb",
    icon: <UKIcon testID="GBFlagIcon" />,
  },
  {
    id: "GD",
    name: "Grenada",
    code: 1,
    regionCode: "gd",
    icon: <GDIcon testID="GDFlagIcon" />,
  },
  {
    id: "GE",
    name: "Georgia",
    code: 995,
    regionCode: "ge",
    icon: <GEIcon testID="GEFlagIcon" />,
  },
  {
    id: "GF",
    name: "French Guiana",
    code: 594,
    regionCode: "gf",
    icon: <GFIcon testID="GFFlagIcon" />,
  },
  {
    id: "GG",
    name: "Guernsey",
    code: 44,
    regionCode: "gg",
    icon: <GGIcon testID="GGFlagIcon" />,
  },
  {
    id: "GH",
    name: "Ghana",
    code: 233,
    regionCode: "gh",
    icon: <GHIcon testID="GHFlagIcon" />,
  },
  {
    id: "GI",
    name: "Gibraltar",
    code: 350,
    regionCode: "gi",
    icon: <GIIcon testID="GIFlagIcon" />,
  },
  {
    id: "GL",
    name: "Greenland",
    code: 299,
    regionCode: "gl",
    icon: <GLIcon testID="GLFlagIcon" />,
  },
  {
    id: "GM",
    name: "Gambia",
    code: 220,
    regionCode: "gm",
    icon: <GMIcon testID="GMFlagIcon" />,
  },
  {
    id: "GN",
    name: "Guinea",
    code: 224,
    regionCode: "gn",
    icon: <GNIcon testID="GNFlagIcon" />,
  },
  {
    id: "GP",
    name: "Guadeloupe",
    code: 590,
    regionCode: "gp",
    icon: <GPIcon testID="GPFlagIcon" />,
  },
  {
    id: "GQ",
    name: "Equatorial Guinea",
    code: 240,
    regionCode: "gq",
    icon: <GQIcon testID="GQFlagIcon" />,
  },
  {
    id: "GR",
    name: "Greece",
    code: 30,
    regionCode: "gr",
    icon: <GRIcon testID="GRFlagIcon" />,
  },
  {
    id: "GT",
    name: "Guatemala",
    code: 502,
    regionCode: "gt",
    icon: <GTIcon testID="GTFlagIcon" />,
  },
  {
    id: "GU",
    name: "Guam",
    code: 1,
    regionCode: "gu",
    icon: <GUIcon testID="GUFlagIcon" />,
  },
  {
    id: "GW",
    name: "Guinea-Bissau",
    code: 245,
    regionCode: "gw",
    icon: <GWIcon testID="GWFlagIcon" />,
  },
  {
    id: "GY",
    name: "Guyana",
    code: 592,
    regionCode: "gy",
    icon: <GYIcon testID="GYFlagIcon" />,
  },
  {
    id: "HK",
    name: "Hong Kong",
    code: 852,
    regionCode: "hk",
    icon: <HKIcon testID="HKFlagIcon" />,
  },
  {
    id: "HN",
    name: "Honduras",
    code: 504,
    regionCode: "hn",
    icon: <HNIcon testID="HNFlagIcon" />,
  },
  {
    id: "HR",
    name: "Croatia",
    code: 385,
    regionCode: "hr",
    icon: <HRIcon testID="HRFlagIcon" />,
  },
  {
    id: "HT",
    name: "Haiti",
    code: 509,
    regionCode: "ht",
    icon: <HTIcon testID="HTFlagIcon" />,
  },
  {
    id: "HU",
    name: "Hungary",
    code: 36,
    regionCode: "hu",
    icon: <HUIcon testID="HUFlagIcon" />,
  },
  {
    id: "ID",
    name: "Indonesia",
    code: 62,
    regionCode: "id",
    icon: <IDIcon testID="IDFlagIcon" />,
  },
  {
    id: "IE",
    name: "Ireland",
    code: 353,
    regionCode: "ie",
    icon: <IEIcon testID="IEFlagIcon" />,
  },
  {
    id: "IL",
    name: "Israel",
    code: 972,
    regionCode: "il",
    icon: <ILIcon testID="ILFlagIcon" />,
  },
  {
    id: "IM",
    name: "Isle of Man",
    code: 44,
    regionCode: "im",
    icon: <IMIcon testID="IMFlagIcon" />,
  },
  {
    id: "IN",
    name: "India",
    code: 91,
    regionCode: "in",
    icon: <INIcon testID="INFlagIcon" />,
  },
  {
    id: "IO",
    name: "British Indian Ocean Territory",
    code: 246,
    regionCode: "io",
    icon: <IOIcon testID="IOFlagIcon" />,
  },
  {
    id: "IQ",
    name: "Iraq",
    code: 964,
    regionCode: "iq",
    icon: <IQIcon testID="IQFlagIcon" />,
  },
  {
    id: "IR",
    name: "Iran",
    code: 98,
    regionCode: "ir",
    icon: <IRIcon testID="IRFlagIcon" />,
  },
  {
    id: "IS",
    name: "Iceland",
    code: 354,
    regionCode: "is",
    icon: <ISIcon testID="ISFlagIcon" />,
  },
  {
    id: "IT",
    name: "Italy",
    code: 39,
    regionCode: "it",
    icon: <ITIcon testID="ITFlagIcon" />,
  },
  {
    id: "JE",
    name: "Jersey",
    code: 44,
    regionCode: "je",
    icon: <JEIcon testID="JEFlagIcon" />,
  },
  {
    id: "JM",
    name: "Jamaica",
    code: 1,
    regionCode: "jm",
    icon: <JMIcon testID="JMFlagIcon" />,
  },
  {
    id: "JO",
    name: "Jordan",
    code: 962,
    regionCode: "jo",
    icon: <JOIcon testID="JOFlagIcon" />,
  },
  {
    id: "JP",
    name: "Japan",
    code: 81,
    regionCode: "jp",
    icon: <JPIcon testID="JPFlagIcon" />,
  },
  {
    id: "KE",
    name: "Kenya",
    code: 254,
    regionCode: "ke",
    icon: <KEIcon testID="KEFlagIcon" />,
  },
  {
    id: "KG",
    name: "Kyrgyzstan",
    code: 996,
    regionCode: "kg",
    icon: <KGIcon testID="KGFlagIcon" />,
  },
  {
    id: "KH",
    name: "Cambodia",
    code: 855,
    regionCode: "kh",
    icon: <KHIcon testID="KHFlagIcon" />,
  },
  {
    id: "KI",
    name: "Kiribati",
    code: 686,
    regionCode: "ki",
    icon: <KIIcon testID="KIFlagIcon" />,
  },
  {
    id: "KM",
    name: "Comoros",
    code: 269,
    regionCode: "km",
    icon: <KMIcon testID="KMFlagIcon" />,
  },
  {
    id: "KN",
    name: "Saint Kitts and Nevis",
    code: 1,
    regionCode: "kn",
    icon: <KNIcon testID="KNFlagIcon" />,
  },
  {
    id: "KP",
    name: "North Korea",
    code: 850,
    regionCode: "kp",
    icon: <KPIcon testID="KPFlagIcon" />,
  },
  {
    id: "KR",
    name: "South Korea",
    code: 82,
    regionCode: "kr",
    icon: <KRIcon testID="KRFlagIcon" />,
  },
  {
    id: "KW",
    name: "Kuwait",
    code: 965,
    regionCode: "kw",
    icon: <KWIcon testID="KWFlagIcon" />,
  },
  {
    id: "KY",
    name: "Cayman Islands",
    code: 1,
    regionCode: "ky",
    icon: <KYIcon testID="KYFlagIcon" />,
  },
  {
    id: "KZ",
    name: "Kazakhstan",
    code: 7,
    regionCode: "kz",
    icon: <KZIcon testID="KZFlagIcon" />,
  },
  {
    id: "LA",
    name: "Laos",
    code: 856,
    regionCode: "la",
    icon: <LAIcon testID="LAFlagIcon" />,
  },
  {
    id: "LB",
    name: "Lebanon",
    code: 961,
    regionCode: "lb",
    icon: <LBIcon testID="LBFlagIcon" />,
  },
  {
    id: "LC",
    name: "Saint Lucia",
    code: 1,
    regionCode: "lc",
    icon: <LCIcon testID="LCFlagIcon" />,
  },
  {
    id: "LI",
    name: "Liechtenstein",
    code: 423,
    regionCode: "li",
    icon: <LIIcon testID="LIFlagIcon" />,
  },
  {
    id: "LK",
    name: "Sri Lanka",
    code: 94,
    regionCode: "lk",
    icon: <LKIcon testID="LKFlagIcon" />,
  },
  {
    id: "LR",
    name: "Liberia",
    code: 231,
    regionCode: "lr",
    icon: <LRIcon testID="LRFlagIcon" />,
  },
  {
    id: "LS",
    name: "Lesotho",
    code: 266,
    regionCode: "ls",
    icon: <LSIcon testID="LSFlagIcon" />,
  },
  {
    id: "LT",
    name: "Lithuania",
    code: 370,
    regionCode: "lt",
    icon: <LTIcon testID="LTFlagIcon" />,
  },
  {
    id: "LU",
    name: "Luxembourg",
    code: 352,
    regionCode: "lu",
    icon: <LUIcon testID="LUFlagIcon" />,
  },
  {
    id: "LV",
    name: "Latvia",
    code: 371,
    regionCode: "lv",
    icon: <LVIcon testID="LVFlagIcon" />,
  },
  {
    id: "LY",
    name: "Libya",
    code: 218,
    regionCode: "ly",
    icon: <LYIcon testID="LYFlagIcon" />,
  },
  {
    id: "MA",
    name: "Morocco",
    code: 212,
    regionCode: "ma",
    icon: <MAIcon testID="MAFlagIcon" />,
  },
  {
    id: "MC",
    name: "Monaco",
    code: 377,
    regionCode: "mc",
    icon: <MCIcon testID="MCFlagIcon" />,
  },
  {
    id: "MD",
    name: "Moldova",
    code: 373,
    regionCode: "md",
    icon: <MDIcon testID="MDFlagIcon" />,
  },
  {
    id: "ME",
    name: "Montenegro",
    code: 382,
    regionCode: "me",
    icon: <MEIcon testID="MEFlagIcon" />,
  },
  {
    id: "MF",
    name: "Saint Martin",
    code: 590,
    regionCode: "mf",
    icon: <MFIcon testID="MFFlagIcon" />,
  },
  {
    id: "MG",
    name: "Madagascar",
    code: 261,
    regionCode: "mg",
    icon: <MGIcon testID="MGFlagIcon" />,
  },
  {
    id: "MH",
    name: "Marshall Islands",
    code: 692,
    regionCode: "mh",
    icon: <MHIcon testID="MHFlagIcon" />,
  },
  {
    id: "MK",
    name: "North Macedonia",
    code: 389,
    regionCode: "mk",
    icon: <MKIcon testID="MKFlagIcon" />,
  },
  {
    id: "ML",
    name: "Mali",
    code: 223,
    regionCode: "ml",
    icon: <MLIcon testID="MLFlagIcon" />,
  },
  {
    id: "MM",
    name: "Myanmar",
    code: 95,
    regionCode: "mm",
    icon: <MMIcon testID="MMFlagIcon" />,
  },
  {
    id: "MN",
    name: "Mongolia",
    code: 976,
    regionCode: "mn",
    icon: <MNIcon testID="MNFlagIcon" />,
  },
  {
    id: "MO",
    name: "Macau",
    code: 853,
    regionCode: "mo",
    icon: <MOIcon testID="MOFlagIcon" />,
  },
  {
    id: "MP",
    name: "Northern Mariana Islands",
    code: 1,
    regionCode: "mp",
    icon: <MPIcon testID="MPFlagIcon" />,
  },
  {
    id: "MQ",
    name: "Martinique",
    code: 596,
    regionCode: "mq",
    icon: <MQIcon testID="MQFlagIcon" />,
  },
  {
    id: "MR",
    name: "Mauritania",
    code: 222,
    regionCode: "mr",
    icon: <MRIcon testID="MRFlagIcon" />,
  },
  {
    id: "MS",
    name: "Montserrat",
    code: 1,
    regionCode: "ms",
    icon: <MSIcon testID="MSFlagIcon" />,
  },
  {
    id: "MT",
    name: "Malta",
    code: 356,
    regionCode: "mt",
    icon: <MTIcon testID="MTFlagIcon" />,
  },
  {
    id: "MU",
    name: "Mauritius",
    code: 230,
    regionCode: "mu",
    icon: <MUIcon testID="MUFlagIcon" />,
  },
  {
    id: "MV",
    name: "Maldives",
    code: 960,
    regionCode: "mv",
    icon: <MVIcon testID="MVFlagIcon" />,
  },
  {
    id: "MW",
    name: "Malawi",
    code: 265,
    regionCode: "mw",
    icon: <MWIcon testID="MWFlagIcon" />,
  },
  {
    id: "MX",
    name: "Mexico",
    code: 52,
    regionCode: "mx",
    icon: <MXIcon testID="MXFlagIcon" />,
  },
  {
    id: "MY",
    name: "Malaysia",
    code: 60,
    regionCode: "my",
    icon: <MYIcon testID="MYFlagIcon" />,
  },
  {
    id: "MZ",
    name: "Mozambique",
    code: 258,
    regionCode: "mz",
    icon: <MZIcon testID="MZFlagIcon" />,
  },
  {
    id: "NA",
    name: "Namibia",
    code: 264,
    regionCode: "na",
    icon: <NAIcon testID="NAFlagIcon" />,
  },
  {
    id: "NC",
    name: "New Caledonia",
    code: 687,
    regionCode: "nc",
    icon: <NCIcon testID="NCFlagIcon" />,
  },
  {
    id: "NE",
    name: "Niger",
    code: 227,
    regionCode: "ne",
    icon: <NEIcon testID="NEFlagIcon" />,
  },
  {
    id: "NF",
    name: "Norfolk Island",
    code: 672,
    regionCode: "nf",
    icon: <NFIcon testID="NFFlagIcon" />,
  },
  {
    id: "NG",
    name: "Nigeria",
    code: 234,
    regionCode: "ng",
    icon: <NGIcon testID="NGFlagIcon" />,
  },
  {
    id: "NI",
    name: "Nicaragua",
    code: 505,
    regionCode: "ni",
    icon: <NIIcon testID="NIFlagIcon" />,
  },
  {
    id: "NL",
    name: "Netherlands",
    code: 31,
    regionCode: "nl",
    icon: <NLIcon testID="NLFlagIcon" />,
  },
  {
    id: "NO",
    name: "Norway",
    code: 47,
    regionCode: "no",
    icon: <NOIcon testID="NOFlagIcon" />,
  },
  {
    id: "NP",
    name: "Nepal",
    code: 977,
    regionCode: "np",
    icon: <NPIcon testID="NPFlagIcon" />,
  },
  {
    id: "NR",
    name: "Nauru",
    code: 674,
    regionCode: "nr",
    icon: <NRIcon testID="NRFlagIcon" />,
  },
  {
    id: "NU",
    name: "Niue",
    code: 683,
    regionCode: "nu",
    icon: <NUIcon testID="NUFlagIcon" />,
  },
  {
    id: "NZ",
    name: "New Zealand",
    code: 64,
    regionCode: "nz",
    icon: <NZIcon testID="NZFlagIcon" />,
  },
  {
    id: "OM",
    name: "Oman",
    code: 968,
    regionCode: "om",
    icon: <OMIcon testID="OMFlagIcon" />,
  },
  {
    id: "PA",
    name: "Panama",
    code: 507,
    regionCode: "pa",
    icon: <PAIcon testID="PAFlagIcon" />,
  },
  {
    id: "PE",
    name: "Peru",
    code: 51,
    regionCode: "pe",
    icon: <PEIcon testID="PEFlagIcon" />,
  },
  {
    id: "PF",
    name: "French Polynesia",
    code: 689,
    regionCode: "pf",
    icon: <PFIcon testID="PFFlagIcon" />,
  },
  {
    id: "PG",
    name: "Papua New Guinea",
    code: 675,
    regionCode: "pg",
    icon: <PGIcon testID="PGFlagIcon" />,
  },
  {
    id: "PH",
    name: "Philippines",
    code: 63,
    regionCode: "ph",
    icon: <PHIcon testID="PHFlagIcon" />,
  },
  {
    id: "PK",
    name: "Pakistan",
    code: 92,
    regionCode: "pk",
    icon: <PKIcon testID="PKFlagIcon" />,
  },
  {
    id: "PL",
    name: "Poland",
    code: 48,
    regionCode: "pl",
    icon: <PLIcon testID="PLFlagIcon" />,
  },
  {
    id: "PM",
    name: "Saint Pierre and Miquelon",
    code: 508,
    regionCode: "pm",
    icon: <PMIcon testID="PMFlagIcon" />,
  },
  {
    id: "PR",
    name: "Puerto Rico",
    code: 1,
    regionCode: "pr",
    icon: <PRIcon testID="PRFlagIcon" />,
  },
  {
    id: "PS",
    name: "Palestine",
    code: 970,
    regionCode: "ps",
    icon: <PSIcon testID="PSFlagIcon" />,
  },
  {
    id: "PT",
    name: "Portugal",
    code: 351,
    regionCode: "pt",
    icon: <PTIcon testID="PTFlagIcon" />,
  },
  {
    id: "PW",
    name: "Palau",
    code: 680,
    regionCode: "pw",
    icon: <PWIcon testID="PWFlagIcon" />,
  },
  {
    id: "PY",
    name: "Paraguay",
    code: 595,
    regionCode: "py",
    icon: <PYIcon testID="PYFlagIcon" />,
  },
  {
    id: "QA",
    name: "Qatar",
    code: 974,
    regionCode: "qa",
    icon: <QAIcon testID="QAFlagIcon" />,
  },
  {
    id: "RE",
    name: "Réunion",
    code: 262,
    regionCode: "re",
    icon: <REIcon testID="REFlagIcon" />,
  },
  {
    id: "RO",
    name: "Romania",
    code: 40,
    regionCode: "ro",
    icon: <ROIcon testID="ROFlagIcon" />,
  },
  {
    id: "RS",
    name: "Serbia",
    code: 381,
    regionCode: "rs",
    icon: <RSIcon testID="RSFlagIcon" />,
  },
  {
    id: "RU",
    name: "Russia",
    code: 7,
    regionCode: "ru",
    icon: <RUIcon testID="RUFlagIcon" />,
  },
  {
    id: "RW",
    name: "Rwanda",
    code: 250,
    regionCode: "rw",
    icon: <RWIcon testID="RWFlagIcon" />,
  },
  {
    id: "SA",
    name: "Saudi Arabia",
    code: 966,
    regionCode: "sa",
    icon: <SAIcon testID="SAFlagIcon" />,
  },
  {
    id: "SB",
    name: "Solomon Islands",
    code: 677,
    regionCode: "sb",
    icon: <SBIcon testID="SBFlagIcon" />,
  },
  {
    id: "SC",
    name: "Seychelles",
    code: 248,
    regionCode: "sc",
    icon: <SCIcon testID="SCFlagIcon" />,
  },
  {
    id: "SD",
    name: "Sudan",
    code: 249,
    regionCode: "sd",
    icon: <SDIcon testID="SDFlagIcon" />,
  },
  {
    id: "SE",
    name: "Sweden",
    code: 46,
    regionCode: "se",
    icon: <SEIcon testID="SEFlagIcon" />,
  },
  {
    id: "SG",
    name: "Singapore",
    code: 65,
    regionCode: "sg",
    icon: <SGIcon testID="SGFlagIcon" />,
  },
  {
    id: "SH",
    name: "Saint Helena",
    code: 290,
    regionCode: "sh",
    icon: <SHIcon testID="SHFlagIcon" />,
  },
  {
    id: "SI",
    name: "Slovenia",
    code: 386,
    regionCode: "si",
    icon: <SIIcon testID="SIFlagIcon" />,
  },
  {
    id: "SJ",
    name: "Svalbard and Jan Mayen",
    code: 47,
    regionCode: "sj",
    icon: <SJIcon testID="SJFlagIcon" />,
  },
  {
    id: "SK",
    name: "Slovakia",
    code: 421,
    regionCode: "sk",
    icon: <SKIcon testID="SKFlagIcon" />,
  },
  {
    id: "SL",
    name: "Sierra Leone",
    code: 232,
    regionCode: "sl",
    icon: <SLIcon testID="SLFlagIcon" />,
  },
  {
    id: "SM",
    name: "San Marino",
    code: 378,
    regionCode: "sm",
    icon: <SMIcon testID="SMFlagIcon" />,
  },
  {
    id: "SN",
    name: "Senegal",
    code: 221,
    regionCode: "sn",
    icon: <SNIcon testID="SNFlagIcon" />,
  },
  {
    id: "SO",
    name: "Somalia",
    code: 252,
    regionCode: "so",
    icon: <SOIcon testID="SOFlagIcon" />,
  },
  {
    id: "SR",
    name: "Suriname",
    code: 597,
    regionCode: "sr",
    icon: <SRIcon testID="SRFlagIcon" />,
  },
  {
    id: "SS",
    name: "South Sudan",
    code: 211,
    regionCode: "ss",
    icon: <SSIcon testID="SSFlagIcon" />,
  },
  {
    id: "ST",
    name: "São Tomé and Príncipe",
    code: 239,
    regionCode: "st",
    icon: <STIcon testID="STFlagIcon" />,
  },
  {
    id: "SV",
    name: "El Salvador",
    code: 503,
    regionCode: "sv",
    icon: <SVIcon testID="SVFlagIcon" />,
  },
  {
    id: "SX",
    name: "Sint Maarten",
    code: 1,
    regionCode: "sx",
    icon: <SXIcon testID="SXFlagIcon" />,
  },
  {
    id: "SY",
    name: "Syria",
    code: 963,
    regionCode: "sy",
    icon: <SYIcon testID="SYFlagIcon" />,
  },
  {
    id: "SZ",
    name: "Eswatini",
    code: 268,
    regionCode: "sz",
    icon: <SZIcon testID="SZFlagIcon" />,
  },
  {
    id: "TA",
    name: "Tristan da Cunha",
    code: 290,
    regionCode: "ta",
    icon: null,
  },
  {
    id: "TC",
    name: "Turks and Caicos Islands",
    code: 1,
    regionCode: "tc",
    icon: <TCIcon testID="TCFlagIcon" />,
  },
  {
    id: "TD",
    name: "Chad",
    code: 235,
    regionCode: "td",
    icon: <TDIcon testID="TDFlagIcon" />,
  },
  {
    id: "TG",
    name: "Togo",
    code: 228,
    regionCode: "tg",
    icon: <TGIcon testID="TGFlagIcon" />,
  },
  {
    id: "TH",
    name: "Thailand",
    code: 66,
    regionCode: "th",
    icon: <THIcon testID="THFlagIcon" />,
  },
  {
    id: "TJ",
    name: "Tajikistan",
    code: 992,
    regionCode: "tj",
    icon: <TJIcon testID="TJFlagIcon" />,
  },
  {
    id: "TK",
    name: "Tokelau",
    code: 690,
    regionCode: "tk",
    icon: <TKIcon testID="TKFlagIcon" />,
  },
  {
    id: "TL",
    name: "Timor-Leste",
    code: 670,
    regionCode: "tl",
    icon: <TLIcon testID="TLFlagIcon" />,
  },
  {
    id: "TM",
    name: "Turkmenistan",
    code: 993,
    regionCode: "tm",
    icon: <TMIcon testID="TMFlagIcon" />,
  },
  {
    id: "TN",
    name: "Tunisia",
    code: 216,
    regionCode: "tn",
    icon: <TNIcon testID="TNFlagIcon" />,
  },
  {
    id: "TO",
    name: "Tonga",
    code: 676,
    regionCode: "to",
    icon: <TOIcon testID="TOFlagIcon" />,
  },
  {
    id: "TR",
    name: "Turkey",
    code: 90,
    regionCode: "tr",
    icon: <TRIcon testID="TRFlagIcon" />,
  },
  {
    id: "TT",
    name: "Trinidad and Tobago",
    code: 1,
    regionCode: "tt",
    icon: <TTIcon testID="TTFlagIcon" />,
  },
  {
    id: "TV",
    name: "Tuvalu",
    code: 688,
    regionCode: "tv",
    icon: <TVIcon testID="TVFlagIcon" />,
  },
  {
    id: "TW",
    name: "Taiwan",
    code: 886,
    regionCode: "tw",
    icon: <TWIcon testID="TWFlagIcon" />,
  },
  {
    id: "TZ",
    name: "Tanzania",
    code: 255,
    regionCode: "tz",
    icon: <TZIcon testID="TZFlagIcon" />,
  },
  {
    id: "UA",
    name: "Ukraine",
    code: 380,
    regionCode: "ua",
    icon: <UAIcon testID="UAFlagIcon" />,
  },
  {
    id: "UG",
    name: "Uganda",
    code: 256,
    regionCode: "ug",
    icon: <UGIcon testID="UGFlagIcon" />,
  },

  {
    id: "UY",
    name: "Uruguay",
    code: 598,
    regionCode: "uy",
    icon: <UYIcon testID="UYFlagIcon" />,
  },
  {
    id: "UZ",
    name: "Uzbekistan",
    code: 998,
    regionCode: "uz",
    icon: <UZIcon testID="UZFlagIcon" />,
  },
  {
    id: "VA",
    name: "Vatican City",
    code: 39,
    regionCode: "va",
    icon: <VAIcon testID="VAFlagIcon" />,
  },
  {
    id: "VC",
    name: "Saint Vincent and the Grenadines",
    code: 1,
    regionCode: "vc",
    icon: <VCIcon testID="VCFlagIcon" />,
  },
  {
    id: "VE",
    name: "Venezuela",
    code: 58,
    regionCode: "ve",
    icon: <VEIcon testID="VEFlagIcon" />,
  },
  {
    id: "VG",
    name: "British Virgin Islands",
    code: 1,
    regionCode: "vg",
    icon: <VGIcon testID="VGFlagIcon" />,
  },
  {
    id: "VI",
    name: "U.S. Virgin Islands",
    code: 1,
    regionCode: "vi",
    icon: <VIIcon testID="VIFlagIcon" />,
  },
  {
    id: "VN",
    name: "Vietnam",
    code: 84,
    regionCode: "vn",
    icon: <VNIcon testID="VNFlagIcon" />,
  },
  {
    id: "VU",
    name: "Vanuatu",
    code: 678,
    regionCode: "vu",
    icon: <VUIcon testID="VUFlagIcon" />,
  },
  {
    id: "WA",
    name: "Samoa",
    code: 685,
    regionCode: "wa",
    icon: <WAIcon testID="WAFlagIcon" />,
  },
  {
    id: "WF",
    name: "Wallis and Futuna",
    code: 681,
    regionCode: "wf",
    icon: <WFIcon testID="WFFlagIcon" />,
  },
  {
    id: "XK",
    name: "Kosovo",
    code: 383,
    regionCode: "xk",
    icon: null,
  },
  {
    id: "YE",
    name: "Yemen",
    code: 967,
    regionCode: "ye",
    icon: <YEIcon testID="YEFlagIcon" />,
  },
  {
    id: "YT",
    name: "Mayotte",
    code: 262,
    regionCode: "yt",
    icon: <YTUNFIcon testID="YTFlagIcon" />,
  },
  {
    id: "ZA",
    name: "South Africa",
    code: 27,
    regionCode: "za",
    icon: <ZAIcon testID="ZAFlagIcon" />,
  },
  {
    id: "ZM",
    name: "Zambia",
    code: 260,
    regionCode: "zm",
    icon: <ZMIcon testID="ZMFlagIcon" />,
  },
  {
    id: "ZW",
    name: "Zimbabwe",
    code: 263,
    regionCode: "zw",
    icon: <ZWIcon testID="ZWFlagIcon" />,
  },
];

export const getCountryCodeById = (id: string) => {
  return (
    CountryCodes.find((countryCode) => countryCode.id === id) || CountryCodes[0]
  );
};
